import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash"
import {DataSet} from "vis-data";
import {LeanPlanningService} from "../../services/lean-planning-service.service";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class RouteTimelineCtrl implements IController {
  isEnabled: any;
  from: any;
  to: any;
  route: any;
  tasksListType: any;
  selectedItemId: any;
  zoom: any;
  canEdit: any;
  queryString: any;
  usePurposeColor: any;
  onTaskSelection: Function;
  onMovedItem: Function;
  onZoomChange: Function;
  onAddSuggestionsToRoute: Function;
  onRecalcRoute: Function;
  onDeleteRoute: Function;

  private container: any;
  private vis: any;
  private options: any;
  private timeline: any;
  private topElementRef: any;
  private tableHeaderDivRef: any;
  private groupsDataSet: any;
  private itemsDataSet: any;
  private taskPurposeToColorMap: any;
  private actionsByStatusMap: any;
  private movingItem: any;
  private headerNode: any;

  private iconsUrl: any;
  private $menuIcon: any;

  // Single delegated click handler for the per-route action panel, attached
  // once on `this.container` after the timeline is created. Replaces the
  // per-cell `actionsDiv.addEventListener` inside `groupTemplate`. The action
  // panel is opened synchronously (no `_onClicked()` digest hop in the
  // original); preserve that by handling it directly here.
  private readonly _onContainerClick = (event: Event) => {
    const target = event.target as Element | null;
    if (!target) return;
    const actionEl = target.closest('[data-bz-action]') as HTMLElement | null;
    if (!actionEl) return;
    const action = actionEl.dataset.bzAction;
    const id = actionEl.dataset.bzId;
    if (!action || !id) return;

    if (action === 'route-action-panel') {
      if (!this.canEdit) return;
      const actions: string[] = [];
      if (this.actionsByStatusMap?.reOptimize) {
        actions.push('Reoptimize');
        actions.push('Reoptimize and Ignore time windows');
      }
      if (this.actionsByStatusMap?.removeRoute) {
        actions.push('Delete');
      }
      if (!actions.length) return;
      this.commonsService.openActionPanel(actions, event)
        .then((reason: string) => {
          if (_.isEqual(reason, 'Reoptimize')) {
            this.onRecalcRoute({routeId: id, ignoreTimeWindows: false});
          } else if (_.isEqual(reason, 'Reoptimize and ignore time windows')) {
            this.onRecalcRoute({routeId: id, ignoreTimeWindows: true});
          } else if (_.isEqual(reason, 'Delete')) {
            this.onDeleteRoute({routeId: id});
          }
        })
        .catch((reason: any) => {
          this.$log.info('Action Panel Closed', reason);
        });
    }
  };

  constructor(private $q: IQService, private confirmDialogService: ConfirmDialogService, private $filter, private $timeout: ITimeoutService, private tasksConstants,
              private commonsDialogService: CommonsDialogService, private $log, private leanPlanningService: LeanPlanningService, private commonsService: CommonsService,
              private IAMPermissions, private leanPlanningConstants, private bringozTimelineService: BringozTimelineService, private moment) {

    this.vis = require('vis-timeline');
    this.taskPurposeToColorMap = this.tasksConstants.purposeToColor;
    this.headerNode = {
      route: document.createElement('span'),
      agent: document.createElement('span')
    };
    this.headerNode.route.textContent = this.$filter('translate')('Route');
    this.headerNode.agent.textContent = this.$filter('translate')('Driver');

    this.iconsUrl = {
      menu: 'assets/images/icons/v2/menu.svg'
    }

    this.$menuIcon = document.createElement('IMG');
    this.$menuIcon.setAttribute("src", this.iconsUrl.menu);
    this.$menuIcon.classList.add('bringoz-icon', 'gray');
  }

  $onInit() {


    // Check permissions to update roues
    if (_.isUndefined(this.canEdit)) {
      this.canEdit = this.IAMPermissions.hasPermission('planning.routes.update') ? this.canEdit : false;
    }

    this.actionsByStatusMap = this.leanPlanningService.getRoutesActionsMap([this.route]);

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet()
    this.itemsDataSet = new DataSet()

    // Set Options
    this.options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.value - b.value;
      },
      groupOrderSwap: (groupDragged, groupToSwap, groups) => {
        const value = groupDragged.value;
        groupDragged.value = groupToSwap.value;
        groupToSwap.value = value;
      },
      groupTemplate: (group) => {
        if (!group) {
          return null;
        }

        const container = document.createElement('div');
        const actionsDiv = document.createElement('div');
        const routeId = document.createElement('span');
        const agentName = document.createElement('span');

        container.style.display = 'flex';
        container.style.alignItems = 'center';
        container.style.width = '250px';

        actionsDiv.classList.add("route-actions");
        actionsDiv.style.setProperty('background-color', group.color);

        const actionsButton = this.$menuIcon.cloneNode(true);
        actionsDiv.appendChild(actionsButton);

        container.appendChild(actionsDiv);

        if (group.id) {
          actionsDiv.dataset.bzAction = 'route-action-panel';
          actionsDiv.dataset.bzId = String(group.id);
        }

        routeId.innerText = group.id;
        routeId.classList.add("margin-left-10");
        container.appendChild(routeId);

        const agentContainer = document.createElement('div');
        agentContainer.classList.add("column-container", "margin-left-10");
        agentName.innerText = group.agentName || '';
        agentContainer.appendChild(agentName);

        const skillsContainer = document.createElement('div');
        skillsContainer.classList.add('skill-tags-container');

        _.forEach(group.agentSkills, (s) => {

          const skill = document.createElement('div');
          skill.classList.add('skill-tag', 'margin-right-5');

          const skillText = document.createElement('span')
          skillText.textContent = s;
          skill.appendChild(skillText);
          skillsContainer.appendChild(skill);
        })
        agentContainer.appendChild(skillsContainer);
        container.appendChild(agentContainer);

        return container;
      },
      onMoving: (item, callback) => {

        if (!this.actionsByStatusMap.editRoute) {
          callback(null);
          return;
        }
        if (item.content != null) {
          callback(item); // updating the item
        } else {
          callback(null); // cancel updating the item
        }
      },
      onMove: (item, callback) => {
        const fromRouteId = item.routeId;
        const toRouteId = item.group;
        const serviceId = item.serviceId;

        if (!this.actionsByStatusMap.editRoute) {
          callback(null);
          return;
        }

        callback(item);
        const canMove = this._canItemMove(item);

        if (!canMove) {
          callback(null);
          return;
        }

        this.confirmDialogService.confirm('Move Delivery From Route', 'Are you sure you want to move this item?', event)
          .then(() => {
            const groupsMap = this.timeline.components[3].groups;
            const isBetweenRoutes = fromRouteId !== toRouteId;

            this.onMovedItem(
              {
                serviceId: serviceId,
                fromRouteId: fromRouteId,
                toRouteId: isBetweenRoutes ? toRouteId : fromRouteId,
                fromOrderedIds: _.chain(
                  groupsMap[fromRouteId].orderedItems.byStart)
                  .filter((item) => {
                    return !_.isEqual(item.data.type, 'background');
                  })
                  .map((filteredItem) => {
                    return filteredItem.data.taskId;
                  })
                  .value(),
                toOrderedIds: isBetweenRoutes ?
                  _.chain(
                    groupsMap[toRouteId].orderedItems.byStart)
                    .filter((item) => {
                      return !_.isEqual(item.data.type, 'background');
                    })
                    .map((filteredItem) => {
                      return filteredItem.data.taskId;
                    })
                    .value() : undefined
              }
            );
            callback(null);
          })
          .catch(() => {
            callback(null);
          })
          .finally(() => {
            this.movingItem = undefined;
          })
      },
      onAdd: (data, callback) => {

        if (!data.items || !data.items.length) {
          callback(null);
          return;
        }

        this.onAddSuggestionsToRoute({routeId: data.group, ids: _.map(data.items, 'id')});
      },
      snap: (date, scale, step) => {
        const minute = 60 * 1000;
        return Math.round(date / minute) * minute;
      },
      orientation: 'top',
      editable: {
        add: this.canEdit,                             // add new items by double tapping
        updateTime: this.canEdit,               // drag items horizontally
        updateGroup: this.canEdit,              // drag items from one group to another
        remove: false,                          // delete an item by tapping the delete button top right
        overrideItems: false                    // allow these options to override item.editable
      },
      groupEditable: true,
      verticalScroll: true,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      margin: {
        item: 5
      },
      stack: false,
      showTooltips: true,
      tooltip: {
        followMouse: true
      },
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      start: this.from ? this.moment(this.from).subtract(1, 'hour') : this.moment().startOf('day'),
      end: this.to ? this.moment(this.to).add(1, 'hour') : this.moment().endOf('day'),
      min: this.from ? this.moment(this.from).subtract(1, 'hour') : '',
      max: this.to ? this.moment(this.to).add(1, 'hour') : '',
      zoomMin: 1080000, // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
    };

    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    // Single delegated click handler — replaces per-cell addEventListener calls
    // inside groupTemplate so listener count stays O(1) regardless of vis redraws.
    this.container.addEventListener('click', this._onContainerClick);

    // Set Table Header + Set Class
    this.topElementRef = this.timeline.body.dom.top;
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("table-header");
    this.topElementRef.before(this.tableHeaderDivRef);

    // Init Groups/Items Data
    this._initTimelineData(this.route);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Timeline Events
    this.timeline.on('select', (properties) => {
      this._onTaskClicked().then(() => {
        const selectedTask = this._getTimelineTaskById(properties.items[0]);
        this.onTaskSelection({taskId: _.get(selectedTask, 'taskId')});
      });
    });
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.isEnabled && !changes.isEnabled.isFirstChange()) {
      if (this.isEnabled) {
        this.$timeout(0).then(() => {
          this._reinitTimeline();
        });
      }
    }

    if (changes.route && !changes.route.isFirstChange() ||
      changes.tasksListType && !changes.tasksListType.isFirstChange()) {
      this.groupsDataSet.clear();
      this.itemsDataSet.clear();
      this._initTimelineData(this.route);

    }

    if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
      const selectedTask = this._getTimelineTaskById(this.selectedItemId);
      if (selectedTask) {
        this.timeline.setSelection(selectedTask.id);
      }
    }

    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {

      this.options.min = this.moment(this.from).subtract(1, 'hour');
      this.options.max = this.moment(this.to).add(1, 'hour');
      this.timeline.setOptions(this.options);
    }

    if (changes.queryString && !changes.queryString.isFirstChange()) {
      this._setGroupVisibilityByQueryString(this.queryString);
    }

    if (changes.zoom && !changes.zoom.isFirstChange()) {
      if (!_.isUndefined(this.zoom)) {
        this.zoom ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
        this.onZoomChange();
      }
    }

  }

  // ******************************
  //        Public methods
  // ******************************

  public onFit() {
    this.$timeout(200).then(() => {
      this.timeline.fit();
      // ctrl.onFit();
    });
  }

  public onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getGroupData(route, index) {
    const assignedCid = _.get(route, 'assignedCid');
    return {
      id: route.rid,
      className: 'group-row md-tiny',
      value: index,
      color: route.color || 'black',
      status: route.status,
      agentName: assignedCid && route.agentReference ? this.$filter('userName')(route.agentReference) : '---',
      agentSkills: this._getTranslatedAgentSkills(_.get(route, 'requiredSkills', []), true),
      resourceName: _.get(route, 'supplyResourceName', '---')
    }
  }

  private _getItemsData(route, tasks) {

    const isEditableRoute = this.actionsByStatusMap.editRoute;
    const routeColor = route.color;

    return _.map(tasks, (task, index) => {

      if (route.analysis[task.id]) {
        task.analysis = route.analysis[task.id];
      }

      const taskServiceTime = _.get(route.analysis[task.id], 'serviceTime');
      const purpose = task.taskSpec.purpose;
      const isPoint = (_.isEqual(task.taskType, 'Internal') && _.isUndefined(taskServiceTime));
      const isBundle = _.isEqual(task.taskType, 'BundledStopover');
      const taskEta = this.leanPlanningService.getRouteTaskEta(route, task);
      const taskEtd = this.leanPlanningService.getRouteTaskEtd(route, task);
      const relations = _.get(task, 'relations', []);
      const taskPurpose = task.taskSpec.purpose;
      const itemColor = this.usePurposeColor ? this.taskPurposeToColorMap[purpose] : routeColor;
      const isLate = _.get(task, 'analysis.late', 0) > 0 && task.status !== 'CourierDeparted';
      // const taskEtd = isRelatedAgentTasks ?
      //     (taskEta + taskServiceTime) :
      //     _.get(task, 'analysis.etd', taskEta + taskServiceTime);
      // const taskEtd = isCompleted ? _.get(task, 'agentArrivalTime') : taskEta + taskServiceTime;
      const taskEtaWindow = this.$filter('timeWindow')({notBefore: taskEta, notAfter: taskEtd});

      return {
        id: task.id,
        // id: route.rid + task.id,
        start: this.moment(taskEta),
        end: this.moment(taskEtd),
        purpose: taskPurpose,
        bundleTasks: _.get(task, 'bundledTaskList', []), // For Bundle Only
        point: isPoint ? 'point' : 'box',
        serviceId: task.serviceId,
        group: route.rid,
        routeId: route.rid,
        taskId: task.id,
        className: isPoint ? 'point' : (isBundle ? 'bundle' : 'task'),
        editable: {
          remove: false,
          updateGroup: isEditableRoute,
          updateTime: isEditableRoute
        },
        title: this.bringozTimelineService.getRouteTaskExtendedTimelineItemTooltip(task, taskEtaWindow, relations),
        content: isPoint ?
          this.bringozTimelineService.getRouteInternalItemContent(task, true) :
          (isBundle ?
            this.bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, relations, true) :
            this.bringozTimelineService.getRouteTaskTimelineItemContent(task, relations, true)),
        // content: isBundle ?
        //     bringozTimelineService.getRouteBundleTaskTimelineItemContent(task, taskEtaWindow, relations, index, true) :
        //     (isPoint ? bringozTimelineService.getRouteInternalItemContent(purpose.charAt(0), route.color) : bringozTimelineService.getRouteTaskTimelineItemContent(task, taskEtaWindow, relations, index, true)),
        // style: 'background-color: ' + itemColor + '; color: white',
        style: 'background-color: ' + routeColor + '; color: white',
      }
    });
  }

  private _clearTimelineData() {
    this.groupsDataSet.clear();
    this.itemsDataSet.clear();
  }

  private _initTimelineData(route) {
    const groups = [];
    let taskItems = [];
    let backgroundItems = [];

    groups.push(this._getGroupData(route, 0));
    const tasksRef = this.tasksListType ? route[this.tasksListType] : route.taskListExt;
    taskItems = taskItems.concat(this._getItemsData(route, tasksRef));
    if (!!_.get(tasksRef, 'length')) {
      backgroundItems = backgroundItems.concat(this._getRouteBackgroundItem(route));
    }

    // Init Groups / Task Items/ Background Items
    this.groupsDataSet.add(groups);
    this.itemsDataSet.add(_.concat(taskItems, backgroundItems));
  }


  private _setGroupsHeader(route) {
    if (!route) {
      while (this.tableHeaderDivRef.firstChild) {
        this.tableHeaderDivRef.removeChild(this.tableHeaderDivRef.firstChild);
      }
    } else if (route) {
      this.topElementRef.style = 'left: 0px';
      this.tableHeaderDivRef.appendChild(this.headerNode.route);
      this.tableHeaderDivRef.appendChild(this.headerNode.agent);
      this.tableHeaderDivRef.classList.add("table-header-container");
    }
  }

  private _onTaskClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getTimelineTaskById(id) {
    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: (item) => {
        return item.id === id || item.taskId === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }


  private _canItemMove(item) {

    const orderedItems = this.timeline.components[3].groups[item.group].orderedItems.byStart;
    const itemIndex = _.findIndex(orderedItems, (orderedItem: any) => {
      return orderedItem.data.taskId === item.taskId;
    });
    const pickupIndexes = _
      .chain(orderedItems)
      .map((orderedItem, index) => {
        return orderedItem.purpose === 'Pickup' ? index : undefined;
      })
      .filter((pickupIndexes) => {
        return !_.isUndefined(pickupIndexes);
      })
      .value();

    return _.every(pickupIndexes, (currentValue) => {
      return currentValue < itemIndex;
    });
  }


  private _reinitTimeline() {
    // Clear Groups/Items Data
    this._clearTimelineData();

    // Init Groups/Items Data
    this._initTimelineData(this.route);

    // Set Groups Header
    this._setGroupsHeader(this.route);

    this._setGroupVisibilityByQueryString(this.queryString);
    // onFit();
  }

  private _getTranslatedAgentSkills(skills, isFirstLetterOnly) {
    return _.map(skills, (s) => {
      return this._getTranslatedSkill(s, isFirstLetterOnly)
    });
  }


  private _getTranslatedSkill(skill, isFirstLetterOnly) {
    const text = this.$filter('translate')('SKILLS.' + skill);
    return isFirstLetterOnly ? text.charAt(0) : text;
  }

  private _setGroupVisibilityByQueryString(queryString) {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.visible = !queryString ||
        _.includes(group, queryString) ||
        _.includes(_.toLower(group.agentName), _.toLower(queryString)) ||
        _.includes(_.toLower(group.resourceName), _.toLower(queryString)) ||
        _.includes(_.toLower(group.id), _.toLower(queryString))
      updatedGroups.push(group);
    });
    this.groupsDataSet.update(updatedGroups);
    this.onFit();
  }

  private _getRouteBackgroundItem(route) {
    return {
      id: route.rid,
      start: this.moment(route.notBefore),
      end: this.moment(route.notAfter),
      group: route.rid,
      type: 'background',
      style: 'background-color: ' + route.color,
      className: 'background'
    }
  }

  $onDestroy() {
    if (this.container) {
      this.container.removeEventListener('click', this._onContainerClick);
      this.container = null;
    }
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }
}

angular
  .module('bringoz.admin.lean-planning')
  .component('routeTimeline', {
      bindings: {
        isEnabled: '<',
        from: '<',
        to: '<',
        route: '<',
        tasksListType: '<?',
        selectedItemId: '<',
        zoom: '<',
        canEdit: '<',
        queryString: '<?',
        usePurposeColor: '<?',
        onTaskSelection: '&',
        onMovedItem: '&',
        onZoomChange: '&',
        onAddSuggestionsToRoute: '&',
        onRecalcRoute: '&',
        onDeleteRoute: '&'
      },
      template: require('./route-timeline.html').default,
      controller: RouteTimelineCtrl
    }
  );
